"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.REAUTHENTICATION_FAILED_ERROR_CODE = void 0;
const errors_1 = require("../errors");
exports.REAUTHENTICATION_FAILED_ERROR_CODE = 4567;
function authenticatedSocket(createSocket) {
    const socket = createSocket();
    const returnObject = Object.assign(Object.assign({}, socket), { login, isAuthenticatedWith: null, authenticated, sessionId: null });
    let waitingForAuth = [];
    let credentials = null;
    socket.addEventListener('open', reauthenticate);
    function login(creds) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            credentials = creds;
            const response = yield socket.request(Object.assign({ messageType: 'LoginRequest' }, creds), 4000);
            if (((_a = response.responseCode) === null || _a === void 0 ? void 0 : _a.name) === 'success') {
                returnObject.isAuthenticatedWith =
                    'accessToken' in creds && ((_b = creds.accessToken) === null || _b === void 0 ? void 0 : _b.startsWith('jwt:'))
                        ? 'jwt'
                        : 'accessToken' in creds
                            ? 'accessToken'
                            : 'sessionId' in creds
                                ? 'sessionId'
                                : 'username' in creds && 'password' in creds
                                    ? 'usernamePassword'
                                    : 'other';
                waitingForAuth.forEach(resolve => resolve());
                waitingForAuth = [];
                if (response.sessionId) {
                    returnObject.sessionId = response.sessionId;
                }
            }
            return response;
        });
    }
    function authenticated() {
        if (returnObject.isAuthenticatedWith) {
            return Promise.resolve();
        }
        return new Promise(resolve => waitingForAuth.push(resolve));
    }
    function reauthenticate() {
        return __awaiter(this, void 0, void 0, function* () {
            returnObject.isAuthenticatedWith = null;
            if (returnObject.sessionId) {
                yield login({ sessionId: returnObject.sessionId })
                    .catch(e => {
                    var _a, _b, _c, _d;
                    if (e instanceof errors_1.CirrusError) {
                        if (((_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.responseCode) === null || _b === void 0 ? void 0 : _b.name) === 'errorAuthentication' && credentials) {
                            return login(credentials);
                        }
                        else if (((_d = (_c = e.response) === null || _c === void 0 ? void 0 : _c.responseCode) === null || _d === void 0 ? void 0 : _d.name) === 'errorDestinationUnavailable') {
                            return new Promise(resolve => setTimeout(() => reauthenticate().then(resolve), 30000));
                        }
                    }
                    throw e;
                })
                    .catch(e => {
                    console.error(e);
                    socket.close(exports.REAUTHENTICATION_FAILED_ERROR_CODE, e);
                });
            }
        });
    }
    return returnObject;
}
exports.default = authenticatedSocket;
//# sourceMappingURL=authenticatedSocket.js.map